const confirmAuthMethod = require('./confirmAuthMethod');

module.exports = ({ values, card }) => {
  switch (card) {
    case 'authentication':
      confirmAuthMethod({ id: values.id });
      break;
  }
};
